module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/4@2x_7ed1df81712a6b925d8e7edd6d4a46db.png";